import React, { useState } from 'react';
import AiReadPanel from './AiReadPanel.jsx';
import MetadataPanel from './MetadataPanel.jsx';
import WindowPanel from './WindowPanel.jsx';
import KeyImagesPanel from './KeyImagesPanel.jsx';
import styles from './RightPanel.module.css';

export default function RightPanel({
  study, parsed, aiRead, aiState,
  onGenerate, onSign, onDictate,
  wc, ww, onWindowChange,
  keyImages = [], onJumpToKeyImage,
}) {
  const [tab, setTab] = useState('ai');

  return (
    <aside className={styles.panel}>
      <nav className={styles.tabs} role="tablist">
        <button role="tab" aria-selected={tab==='ai'}     className={tab==='ai'     ? styles.active : styles.tab} onClick={() => setTab('ai')}>AI Read</button>
        <button role="tab" aria-selected={tab==='keys'}   className={tab==='keys'   ? styles.active : styles.tab} onClick={() => setTab('keys')}>Keys</button>
        <button role="tab" aria-selected={tab==='meta'}   className={tab==='meta'   ? styles.active : styles.tab} onClick={() => setTab('meta')}>Meta</button>
        <button role="tab" aria-selected={tab==='window'} className={tab==='window' ? styles.active : styles.tab} onClick={() => setTab('window')}>W/L</button>
      </nav>
      <div className={styles.body}>
        {tab === 'ai'     && <AiReadPanel aiRead={aiRead} state={aiState} onGenerate={onGenerate} onSign={onSign} onDictate={onDictate} />}
        {tab === 'keys'   && <KeyImagesPanel keyImages={keyImages} onJump={onJumpToKeyImage} />}
        {tab === 'meta'   && <MetadataPanel study={study} parsed={parsed} />}
        {tab === 'window' && <WindowPanel wc={wc} ww={ww} onChange={onWindowChange} />}
      </div>
    </aside>
  );
}
